const logData = (title?: any, data?: any) => {
  if (import.meta.env.DEV) {
    console.log('--------------------------');
    if (title) {
      console.log(title);
    }
    if (data) {
      console.log(data);
    }
    console.log('--------------------------');
  }
};

const warnData = (title?: any, data?: any) => {
  if (import.meta.env.DEV) {
    console.warn('--------------------------');
    if (title) {
      console.warn(title);
    }
    if (data) {
      console.warn(data);
    }
    console.warn('--------------------------');
  }
};

const errorData = (title?: any, data?: any) => {
  if (import.meta.env.DEV) {
    console.error('--------------------------');
    if (title) {
      console.error(title);
    }
    if (data) {
      console.error(data);
    }
    console.error('--------------------------');
  }
};

export { logData, warnData, errorData };
